import { addNotification } from "@/core/services/NotificationService";
import { toLocalDate } from "../dateHelper";
import NotificationDialog from "../notificationDialog";
import RobotTypeValue from "@/models/enums/RobotType";
import RobotStatusValue from "@/models/enums/RobotStatus";
import { getWord } from "../translator";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import store from "@/store";

const onRobotCreated = (newRobot) => {
    if (newRobot) {
        addNotification({
            title: "RobotCreated",
            description: `ClickTitleToViewDetails`,
            time: toLocalDate(Date.now()),
            route: `/configuration/robot/${newRobot.id}`
        });

        if (store.getters.getDataType == "Robot") {
            const data = {
                id: newRobot.id,
                companyId: newRobot.companyId,
                name: newRobot.name,
                type: RobotTypeValue.GetText(newRobot.type),
                status: RobotStatusValue.GetText(newRobot.status),
                lastStatusDate: toLocalDate(newRobot.lastStatusDate),
                active: newRobot.active ? getWord("Yes") : getWord("No"),
            };

            if (store.getters.getTableData.length === store.getters.getPageSize) {
                const newList = [{ isNew: true, ...data }, ...store.getters.getTableData.slice(0, store.getters.getPageSize - 1)];
                store.commit(Mutations.SET_TABLE_DATA, newList);
            }
            else {
                const newList = [{ isNew: true, ...data }, ...store.getters.getTableData];
                store.commit(Mutations.SET_TABLE_DATA, newList);
            }
        }
    }
}

const onRobotDeleted = (deletedRobot) => {
    if (deletedRobot) {
        NotificationDialog.Notify("RobotDeleted", deletedRobot.name);

        if (store.getters.getDataType == "Robot") {
            const list = store.getters.getTableData.map((_data) => {
                if (_data.id !== deletedRobot.id) {
                    return _data;
                }
            });

            store.commit(Mutations.SET_TABLE_DATA, list);
        }
    }
}

const onRobotStatusChanged = (updatedRobot) => {
    if (updatedRobot) {
        const status = updatedRobot.status
        if (status === 0) {
            addNotification({
                title: "RobotIsUnresponsive",
                description: `ClickTitleToViewDetails`,
                time: toLocalDate(Date.now()),
                route: `/configuration/robot/${updatedRobot.id}`
            });

            NotificationDialog.NotifyError("RobotIsUnresponsive", updatedRobot.name)
        }
        else if (status === 1) {
            addNotification({
                title: "RobotIsOnline",
                description: `ClickTitleToViewDetails`,
                time: toLocalDate(Date.now()),
                route: `/configuration/robot/${updatedRobot.id}`
            });

            NotificationDialog.Notify("RobotIsOnline", updatedRobot.name)
        }
        else {
            addNotification({
                title: "RobotIsBusy",
                description: `ClickTitleToViewDetails`,
                time: toLocalDate(Date.now()),
                route: `/configuration/robot/${updatedRobot.id}`
            });

            NotificationDialog.NotifyInfo("RobotIsBusy", updatedRobot.name)
        }

        if (store.getters.getDataType == "Robot") {
            const list = store.getters.getTableData.map((_data) => {
                if (_data.id === updatedRobot.id) {
                    _data.isUpdated = true;
                    _data.companyId = updatedRobot.companyId;
                    _data.name = updatedRobot.name;
                    _data.type = getWord(RobotTypeValue.GetText(updatedRobot.type));
                    _data.status = getWord(RobotStatusValue.GetText(updatedRobot.status));
                    _data.lastStatusDate = toLocalDate(updatedRobot.lastStatusDate);
                    _data.active = updatedRobot.active ? getWord("Yes") : getWord("No");
                }

                return _data;
            });

            store.commit(Mutations.SET_TABLE_DATA, list);
        }
    }
}

const onRobotActiveStateChanged = (updatedRobot) => {
    if (updatedRobot) {
        const active = updatedRobot.active
        if (active) {
            NotificationDialog.Notify("RobotIsActive", updatedRobot.name)
        }
        else {
            NotificationDialog.NotifyError("RobotIsNotActive", updatedRobot.name)
        }

        if (store.getters.getDataType == "Robot") {
            const list = store.getters.getTableData.map((_data) => {
                if (_data.id === updatedRobot.id) {
                    _data.isUpdated = true;
                    _data.companyId = updatedRobot.companyId;
                    _data.name = updatedRobot.name;
                    _data.type = getWord(RobotTypeValue.GetText(updatedRobot.type));
                    _data.status = getWord(RobotStatusValue.GetText(updatedRobot.status));
                    _data.lastStatusDate = toLocalDate(updatedRobot.lastStatusDate);
                    _data.active = updatedRobot.active ? getWord("Yes") : getWord("No");
                }

                return _data;
            });

            store.commit(Mutations.SET_TABLE_DATA, list);
        }
    }
}

const onRobotStatisticsChanged = (statistics) => {
    if (statistics && statistics.robot) {
        store.dispatch(Actions.SET_ROBOT_STATUS_STATISTICS, statistics.robot)
    }
}

export { onRobotCreated, onRobotDeleted, onRobotStatusChanged, onRobotActiveStateChanged, onRobotStatisticsChanged }